import './App.css';

 import Images from './components/Images';
import Footer from './components/Footer';


import { Container } from 'react-bootstrap';
function App() {
  return (

  <div className="App" >
      <Container>
       <Images />
        <Footer />
      </Container>
    </div>
  );
}

export default App;
